






import Vue from "vue";
// @ts-ignore
import CodeMirror from "codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/monokai.css";
import "codemirror/mode/yaml/yaml.js";

export default Vue.extend({
  name: "ShowYaml",
  data() {
    return {
      dialog: false,
      title: "",
      previewEditor: null as any
    };
  },
  methods: {
    show(data: string, name: string) {
      this.dialog = true;
      this.title = name;
      this.$nextTick(() => {
        this.previewEditor = CodeMirror(document.getElementById("preview"), {
          mode: "text/x-yaml",
          theme: "monokai",

          readOnly: true,
          value: data
        });
      });
    },
    quit() {
      this.previewEditor = null;
      setTimeout(() => {
        const pre = document.querySelector("#preview");
        if (pre) {
          pre.innerHTML = "";
        }
      }, 500);
    }
  }
});
